import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Toaster } from '@aaas/shared';
import { KmsSidebar } from '../components/KmsSidebar';

export interface KmsLayoutProps {
  children: React.ReactNode;
}

export function KmsLayout({ children }: KmsLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      {/* Sidebar - Hidden on mobile by default, visible on desktop */}
      <KmsSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Main content area with left margin for fixed sidebar on desktop */}
      <div className="flex flex-col min-h-screen lg:ml-64">
        {/* Mobile menu button */}
        <div className="lg:hidden border-b border-gray-200 bg-white px-4 py-3">
          <button
            onClick={toggleSidebar}
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
            aria-label="Open sidebar"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {/* Page content */}
        <main className="flex-1 bg-gray-50">
          <div className="w-full p-6">{children}</div>
        </main>
      </div>

      {/* Toast notifications */}
      <Toaster />
    </>
  );
}
